import { render, staticRenderFns } from "./myCards.vue?vue&type=template&id=3ae4d38d&scoped=true&"
import script from "./myCards.vue?vue&type=script&lang=js&"
export * from "./myCards.vue?vue&type=script&lang=js&"
import style0 from "./myCards.vue?vue&type=style&index=0&id=3ae4d38d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae4d38d",
  null
  
)

export default component.exports